import { Component } from '@angular/core';

import { NotificationService } from '../../../../core/services/notification.service';
import { ConfigService } from '../../../../core/services/config.service';
import {Subject} from 'rxjs/Rx';
import { ProductGroupService } from './product-group.service';

@Component({
  selector: 'itpx-product-groups',
  templateUrl: './product-groups.component.html',
  styleUrls: ['./product-groups.component.css']
})
export class ProductGroupsComponent {

    private url: string;
    private productUrl: string;
    private filterStatusFields: any;
    private detailsRoute: string = '/agora/product-data/product-groups/{{key}}/details';
    private queryParams = new URLSearchParams();
    private query: any = {};
    private filterProductSellerFields: any= {};
    private filterProductCategoriesFields : any = {};
    private baseUrl: string;
    private gridRefresh = new Subject<any>();
    private draftGridRefresh = new Subject<any>();
    private fields: Array<any> = [
        {
            title: 'Code',
            name: 'code',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }, {
            title: 'Name',
            name: 'name'
        }, 
        {
            title: 'Parent Category',
            name: 'category.name',
        }, 
        {
            title: 'Topics',
            name: (data: any) => {
                return data.subTopics.map(_ => _.title).join(', ')
            }
        },{
            title: 'Seller',
            name: 'domain'
        },{
            title: 'Online',
            name: 'online',
            config: {
                type: 'map-inner-html',
                map: {
                    true: '<span><i class="fa fa-circle green-online" aria-hidden="true"></i></span>',
                    false: '<span><i class="fa fa-circle red-offline" aria-hidden="true"></i></span>'
                },
                icon: {
                    true: 'fa-circle green-online',
                    false: 'fa-circle red-offline'
                }
            },
            weight: 0.5
        }
    ];

    ngOnInit() {
        this.getFilters();
    }

    constructor( private configService: ConfigService , private service: ProductGroupService) {
        //this.url = this.configService.get('server').url + this.configService.get('endpoints').agora.productGroups.sortedList.api;
        this.url = this.configService.get('server').url + this.configService.get('endpoints').agora.productGroups.filteredList.api+'?';
        this.baseUrl = this.configService.get('server').url + this.configService.get('endpoints').agora.productGroups.filteredList.api+'?';
    }

    private getFilters() {
        this.filterStatusFields = {
            title: 'Status',
            key: 'status',
            options: [
                {
                    value: 'Online',
                    key: 'online',
                    checked: true
                },
                {
                    value: 'Offline',
                    key: 'offline',
                    checked: true
                },
            ]
        };
        this.getCategoryFilterList();
        this.getSellerFilterList();
    }

    private getSellerFilterList(){
        this.service.getSellerDict()
            .subscribe(
                body => {
                    this.filterProductSellerFields = {
                        title: 'Seller',
                        key: 'sellerId',
                        options: this.extractFilterOptions(body.data),
                        config: {
                            dropdownType: true
                        }
                    }
                }
            );
    }

    private getCategoryFilterList() {
        this.service.getCategoryDict()
            //.bindToLifecycle(this)
            .subscribe(
                body => {
                    this.filterProductCategoriesFields = {
                        title: 'Parent Category',
                        key: 'categoryId',
                        options: this.extractFilterOptions(body.data),
                        config: {
                            dropdownType: true
                        }
                    }
                }
            );

    }

    private extractFilterOptions(dict: Array<any>) {
        let results = [];
        if (Array.isArray(dict)) {
            dict.forEach(el => {
                if (el.hasOwnProperty('configKey')) {
                    results.push({
                        checked: true,
                        key: el.id,
                        value: el.configValue
                    })
                } else if (!el.hasOwnProperty('configKey') && el.hasOwnProperty('key')) {
                    results.push({
                        checked: true,
                        key: el.key,
                        value: el.value
                    })
                } else if(el.hasOwnProperty('name')) {
                    results.push({
                        checked: true,
                        key: el.id,
                        value: el.name
                    })
                }
                return results
            })
        }
        return results;
    }

    private onFilterChanges(event: any) {
        let id =  event.id || null;
        //console.log("event",event);
        //console.log("event.id",event.id);
        let items = event.status || null;
        //console.log("event.status",event.status);
        /*if (items['sellerId'] ) {
           this.query['sellerId'] = null;
        }

        if (items['categoryId']) {
            this.query['categoryId'] = null;
         }*/

        if (id && items) {
            //let keys =  Object.keys(items);
            //console.log("keys",keys);
            if(id == 'status'){
                if(event.status.online == true && event.status.offline == false) {
                    this.queryParams.set('online', 'true');
                } else if (event.status.online == false && event.status.offline == true) {
                    this.queryParams.set('online', 'false');
                } else {
                    this.queryParams.delete('online');
                }
            }else{
                if(event.status[event.id] != null)
                    this.queryParams.set(id, event.status[event.id]);
            }
            console.log("this.queryParams", this.queryParams.toString());
        }
        this.url = this.baseUrl + this.queryParams.toString();
        console.log(this.url);
        setTimeout(_ => this.gridRefresh.next(true), 1);
    }

    private clearUrlParams() {
        this.queryParams.delete('online');
        this.queryParams.delete('categoryId');
        this.queryParams.delete('sellerId')
        this.query = {};
        this.url = this.baseUrl;
        return  this.queryParams;
    }

    private clearSortingClicked(e){
        this.clearUrlParams();
        this.getFilters();
        setTimeout(_ =>  {
            this.gridRefresh.next(true)
        }, 3);
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-groups/product-groups.component.ts